export const ADD_LOADER = 'layout/ADD_LOADER';
export const REMOVE_LOADER = 'layout/REMOVE_LOADER';
export const TOGGGLE_DISPLAY_PRICING_INFO =
  'layout/TOGGGLE_DISPLAY_PRICING_INFO';
